import { UrlConstants } from "../url.constants";
export class ApiBusinessLicenceConstants {
    static URL = UrlConstants.API_V2 + "BusinessLicence";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetBusinessLicenceApplicantAndApplicantAgent";
    static FUNCTION_SET_PROPERTIES = "SetBusinessLicenceProperties";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateBusinessLicenceInvoiceReport";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalBusinessLicenceApplication";
    static FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST = "GetBusinessLicenceRequiredDocumentsChecklist";
    static FUNCTION_UPDATE_BUSINESS_OWNER = "UpdateBusinessLicenceBusinessOwner";
    static FUNCTION_GET_EXTERNAL_LINKS = "GetExternalLinks";
}
